module.exports = __webpack_public_path__ + "img/FugeGroß.e77d702b.jpg";